// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};